import React, { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import { api, API } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Download, Award } from "lucide-react";
import { toast } from "sonner";

const TITLES = {
  new_hire: "New Hire Training",
  annual: "Annual Resilience Training",
  critical_incident: "Critical Incident Debrief",
};

export default function Certificates() {
  const [modules, setModules] = useState([]);
  useEffect(() => { api.get("/modules").then(r => setModules(r.data)).catch(() => {}); }, []);
  const ready = modules.filter(m => m.certificate_issued_at);

  const downloadCert = async (mod) => {
    try {
      const r = await api.get(`/modules/${mod.module_type}/certificate`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(r.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `haruki_${mod.module_type}_certificate.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Certificate not yet available.");
    }
  };

  return (
    <MemberLayout>
      <div className="haruki-fade-in">
        <h1 className="font-heading text-2xl font-bold sm:text-3xl">Your certificates</h1>
        <p className="mt-2 text-sm text-muted-foreground">CEU certificates are downloadable by you only.</p>

        {ready.length === 0 ? (
          <Card className="mt-6"><CardContent className="p-6 text-sm text-muted-foreground">Complete a module to issue your first certificate.</CardContent></Card>
        ) : (
          <div className="mt-6 space-y-3">
            {ready.map((m) => (
              <Card key={m.module_type}>
                <CardContent className="flex items-center justify-between gap-4 p-5">
                  <div className="flex items-center gap-3">
                    <Award className="h-5 w-5" style={{ color: "hsl(var(--haruki-teal))" }} />
                    <div>
                      <div className="font-heading text-sm font-semibold">{TITLES[m.module_type] || m.module_type}</div>
                      <div className="text-xs text-muted-foreground">Issued {m.certificate_issued_at.slice(0, 10)}</div>
                    </div>
                  </div>
                  <Button
                    data-testid={`certificate-download-${m.module_type}`}
                    onClick={() => downloadCert(m)}
                    variant="outline"
                  >
                    <Download className="mr-2 h-4 w-4" /> PDF
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </MemberLayout>
  );
}
